import {
    getDirectoryRecordsDictionary,
    getSectionsDictionary,
} from '~/src/repositories/cms/shared/cms.base.repository';
import { CmsCategoryCodeEnum, CmsDirectoryCodeEnum } from '~/src/models/enums/cms.enum';
import { getMappedReferralUrlsData } from '~/src/repositories/cms/entities/referral-urls/utils/cms.referral-urls.utils';

export const getMtsProductsForReferralUrl = async (isSSR?: boolean) => {
    const data = await getSectionsDictionary({ isSSR, categoryCode: CmsCategoryCodeEnum.REFERRAL_URLS });
    const productGroups = await getDirectoryRecordsDictionary({
        isSSR,
        directoryCode: CmsDirectoryCodeEnum.PRODUCT_GROUP,
    });

    return getMappedReferralUrlsData(productGroups, data);
};
